module.exports = __webpack_public_path__ + "img/brand_06.552693bf.png";